import { BUTTON_SIZES, DestructiveButton } from 'ui/button';
import { MODAL_SIZES, MODAL_VARIANTS, Modal, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';
import { useModalContext, ModalType, useCampaignContext } from '../../context';
import { BoldText } from '../../styles';
import { useDeactivateCampaign } from './useDeactivateCampaign';

export const DEACTIVATE_CAMPAIGN_MODAL_TEST_ID = 'deactivate-campaign-modal';
export const DEACTIVATE_CAMPAIGN_BUTTON_TEST_ID = 'deactivate-campaign-button';

export const DeactivateCampaignModal = () => {
  const { closeModal } = useModalContext();
  const { isLoading, deactivateCampaign } = useDeactivateCampaign();
  const {
    campaign: { name },
  } = useCampaignContext();

  const handleConfirm = () => {
    deactivateCampaign();
  };

  return (
    <Modal
      withPortal
      isModalOpen={true}
      onClose={() => closeModal(ModalType.DeactivateCampaignModal)}
      id="deactivate-modal"
      data-test={DEACTIVATE_CAMPAIGN_MODAL_TEST_ID}
      size={MODAL_SIZES.SMALL}
      variant={MODAL_VARIANTS.DELETE}
    >
      <ModalHeader>Deactivate campaign?</ModalHeader>
      <ModalBody>
        Are you sure you want to deactivate <BoldText>{name}</BoldText>? This will stop messages
        from sending.
      </ModalBody>
      <ModalFooter>
        <DestructiveButton
          data-test={DEACTIVATE_CAMPAIGN_BUTTON_TEST_ID}
          onClick={handleConfirm}
          isLoading={isLoading}
          size={BUTTON_SIZES.LARGE}
        >
          Deactivate campaign
        </DestructiveButton>
      </ModalFooter>
    </Modal>
  );
};
